export default function InitCKEditor() {
    document.querySelectorAll('.rich-text li').forEach(function(li) {
        li.innerHTML = `<span>${li.innerHTML}</span>`;
    });
}
